import React from "react";
import { Field } from "formik";
import Typography from "@material-ui/core/Typography";
import MuiTextInput from "../../Common/MuiTextInput";
import { FormSection, FormRow } from "./UIComponents";

export default ({ a, i, language, canEditForm }) => {
  return (
    <FormSection>
      <Typography variant="h2">
        {a
          ? language.Account_Address_Type[a.type]
          : language.Account_Address_Type["Generic"]}
      </Typography>
      <FormRow gtc="3fr 1fr">
        <Field
          name={`addresses[${i}].street`}
          label={language.Account_Address_Street.Label}
          placeholder={language.Account_Address_Street.Placeholder}
          component={MuiTextInput}
          disabled={!canEditForm}
          type="text"
          autocomplete="address-line1"
        />
        <Field
          name={`addresses[${i}].streetNumber`}
          label={language.Account_Address_StreetNumber.Label}
          placeholder={language.Account_Address_StreetNumber.Placeholder}
          component={MuiTextInput}
          disabled={!canEditForm}
          type="text"
          autocomplete="address-line2"
        />
      </FormRow>
      <FormRow gtc="1fr 3fr">
        <Field
          name={`addresses[${i}].zipCode`}
          label={language.Account_Address_ZipCode.Label}
          placeholder={language.Account_Address_ZipCode.Placeholder}
          component={MuiTextInput}
          disabled={!canEditForm}
          type="text"
          autocomplete="postal-code"
        />
        <Field
          name={`addresses[${i}].city`}
          label={language.Account_Address_City.Label}
          placeholder={language.Account_Address_City.Placeholder}
          component={MuiTextInput}
          disabled={!canEditForm}
          type="text"
          autocomplete="address-level2"
        />
      </FormRow>
      <FormRow>
        <Field
          name={`addresses[${i}].countryCode`}
          label={language.Account_Address_CountryCode.Label}
          placeholder={language.Account_Address_CountryCode.Placeholder}
          component={MuiTextInput}
          disabled={!canEditForm}
          type="text"
          autocomplete="country"
        />
      </FormRow>
    </FormSection>
  );
};
